import React from 'react';
import { NavLink } from "react-router-dom";
import { mock } from './mock';
let Nav = (props) => {
    const nav = mock.nav;
    return (
        <>
            <div className="navbars">
                <ul className="list-group list-group-flush">
                    {
                        nav?.map((item,index)=> {
                            return <li key={index} className="list-group-item">
                                       <NavLink exact activeClassName="active" onClick={props.clickHandle} className="d-block text-capitalize" to={`/genre/${item.genrs}`} data-bs-dismiss="offcanvas"><i className="bi bi-chevron-compact-right"></i> {item.genrs}</NavLink >
                                    </li>
                        })
                    }

                </ul>
            </div>
        </>
    );
}

export default Nav;
